import { createBrowserRouter, redirect } from "react-router-dom";
import AuthGuard from "./auth/AuthGuard";
import adminRoutes from "./views/Admin/adminRoutes";
import distributorRoutes from "./views/Distributor/distributorRoutes";
import Error404 from "./views/sessions/Error";
import sessionsRoutes from "./views/sessions/sessionsRoutes";
import supplierRoutes from "./views/Supplier/supplierRoutes";

const routes = createBrowserRouter([
  {
    element: <AuthGuard />,
    children: [...adminRoutes, ...distributorRoutes, ...supplierRoutes],
  },
  ...sessionsRoutes,
  {
    path: "/",
    exact: true,
    loader: () => redirect("/signin"),
  },
  {
    path: "*",
    element: <Error404 />,
  },
]);

export default routes;
